
<div :class="classes">
  <slot></slot>
  <span v-if="error" class="error-text">{{ message || error.message }}</span>
</div>
